import * as z from "zod/v4";

export const investmentManagementFormSchema = z.object({
	email: z.email(),
	firstName: z.string().min(1),
	lastName: z.string().min(1),
	phone: z
		.string()
		.regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Please enter a valid 10-digit phone number"),
	message: z.string().min(1),
	investmentAmount: z.enum([
		"$25,000 - $50,000",
		"$50,000 - $100,000",
		"$100,000 - $250,000",
		"$250,000+"
	]),
	investmentTimeline: z.enum([
		"Just exploring options",
		"Within 30 Days",
		"1-3 Months",
		"3-6 Months",
		"6+ Months"
	]),
	iAmAnAccreditedInvestor: z.boolean(),
	howDidYouHearAboutUs: z.string().min(1),
	agreedToTermsAndPrivacy: z
		.boolean()
		.refine((v) => v === true, "You must agree to the Privacy Policy and Terms & Conditions"),
	turnstileToken: z.string()
});

export type InvestmentManagementFormSchema = z.infer<typeof investmentManagementFormSchema>;

export const investmentAmountOptions =
	investmentManagementFormSchema.shape.investmentAmount.options;
export const investmentTimelineOptions =
	investmentManagementFormSchema.shape.investmentTimeline.options;
